import { faker } from '@faker-js/faker'

import { Doctor } from '../../contracts/doctor'

export function createRandomDoctor(): Doctor {
  const doctor: Doctor = {
    id: faker.number.int(),
    createTime: faker.number.int(),
    updateTime: faker.number.int(),
    status: faker.number.int(),
    name: faker.company.name(),
    licenseNumber: faker.string.alphanumeric(10),
    agreeTime: faker.number.int(),
    doctorType: faker.word.sample(),
    history: faker.lorem.sentence(),
    memo: faker.lorem.paragraph(),
    priority: faker.number.int(),
    rating: faker.number.int(),
    ratingCount: faker.number.int(),
    reviewCount: faker.number.int(),
    isCeo: faker.datatype.boolean(),
    sex: faker.word.sample(),
    liveConsultationCount: faker.number.int(),
    seq: faker.number.int(),
    hospital: {
      id: faker.number.int(),
      createTime: faker.number.int(),
      updateTime: faker.number.int(),
      lastLoginTime: faker.number.int(),
      status: faker.word.sample(),
      memo: faker.lorem.paragraph(),
      lastAccountAddedTime: faker.number.int(),
      priority: faker.number.int(),
      group: {
        id: faker.number.int(),
        createTime: faker.number.int(),
        updateTime: faker.number.int(),
        name: faker.word.sample(),
        feeReview: faker.number.int(),
        feeEvent: faker.number.int(),
        feeEstimate: faker.number.int(),
        feeChatOpen: faker.number.int(),
        feeConFixed: faker.number.int(),
        feeConsultation: faker.number.int(),
        feeReviewConsultation: faker.number.int(),
        feeBonusPhoneFixed: faker.number.int(),
        feeLiveConsultation: faker.number.int(),
        temporaryUnavailableGroup: faker.datatype.boolean(),
        dormantGroup: faker.datatype.boolean(),
      },
      previousGroup: {
        id: faker.number.int(),
        createTime: faker.number.int(),
        updateTime: faker.number.int(),
        name: faker.word.sample(),
        feeReview: faker.number.int(),
        feeEvent: faker.number.int(),
        feeEstimate: faker.number.int(),
        feeChatOpen: faker.number.int(),
        feeConFixed: faker.number.int(),
        feeConsultation: faker.number.int(),
        feeReviewConsultation: faker.number.int(),
        feeBonusPhoneFixed: faker.number.int(),
        feeLiveConsultation: faker.number.int(),
        temporaryUnavailableGroup: faker.datatype.boolean(),
        dormantGroup: faker.datatype.boolean(),
      },
      useYn: faker.word.sample(),
      rating: faker.number.int(),
      ratingCount: faker.number.int(),
      operationType: faker.word.sample(),
      documents: {
        signedApplicationDocuments: [faker.string.uuid()],
        hospitalBusinessLicenseFiles: [faker.string.uuid()],
        medicalFacilitiesPermissionFiles: [faker.string.uuid()],
        businessLicenseFilesForTaxBill: [faker.string.uuid()],
        agencyBusinessLicenseFiles: [faker.string.uuid()],
      },
      adsCount: faker.number.int(),
      liveConsultationCount: faker.number.int(),
      inChargeName: faker.company.name(),
      treatmentMenuId: faker.number.int(),
      enableTreatmentMenu: faker.datatype.boolean(),
      recentConsultationMemberCount: faker.number.int(),
      recentVisitedMemberCount: faker.number.int(),
      recentOperatedMemberCount: faker.number.int(),
      rcmdRating: faker.number.int(),
      treatmentCategoryTagIds: faker.word.sample(),
      country: faker.location.country(),
      name: faker.company.name(),
      address: faker.location.streetAddress(),
      profileImage: faker.image.url(),
      profileComment: faker.lorem.sentence(),
      mainImage: faker.image.url(),
      authTenderView: faker.datatype.boolean(),
      authEstimateWrite: faker.datatype.boolean(),
      authChatConsultation: faker.datatype.boolean(),
      smsNumber: faker.phone.number(),
      staffName: faker.company.name(),
      pageCount: faker.number.int(),
      reviewCount: faker.number.int(),
      agreedToTermsTime: faker.number.int(),
      canNormalConsultation: faker.datatype.boolean(),
      districtCode: faker.word.sample(),
      opTagList: [faker.word.sample()],
      authForeignConsultation: faker.datatype.boolean(),
      lat: Number(faker.location.latitude()),
      lng: Number(faker.location.longitude()),
      sido: faker.location.state(),
      transls: {
        ja: {
          name: faker.company.name(),
          introduction: faker.lorem.paragraph(),
        },
      },
      cardLevel: faker.number.int(),
      basicRN: faker.word.sample(),
      basicVN: faker.word.sample(),
      assessmentState: faker.word.sample(),
      mainTel1: faker.phone.number(),
      mainTel2: faker.phone.number(),
      mainTel3: faker.phone.number(),
      addressEn: faker.location.streetAddress(),
      zipCode: faker.location.zipCode(),
      sigungu: faker.word.sample(),
      sigunguCode: faker.word.sample(),
      officeHoursJson: JSON.stringify({
        weekdays: [
          {
            day: 'Monday',
            startTime: '09:00 AM',
            endTime: '06:00 PM',
          },
          {
            day: 'Tuesday',
            startTime: '09:00 AM',
            endTime: '06:00 PM',
          },
          {
            day: 'Wednesday',
            startTime: '09:00 AM',
            endTime: '06:00 PM',
          },
          {
            day: 'Thursday',
            startTime: '09:00 AM',
            endTime: '06:00 PM',
          },
          {
            day: 'Friday',
            startTime: '09:00 AM',
            endTime: '06:00 PM',
          },
          {
            day: 'Saturday',
            startTime: '09:00 AM',
            endTime: '12:00 PM',
          },
        ],
        sunday: [],
        holidays: [],
        other: [],
      }),
      officeHoursEtc: faker.lorem.sentence(),
      introduction: faker.lorem.paragraph(),
      badgeCodeList: [faker.word.sample()],
      authTreatmentPurchase: faker.datatype.boolean(),
      staffTel1: faker.phone.number(),
      staffTel2: faker.phone.number(),
      staffTel3: faker.phone.number(),
      introImage: faker.image.url(),
      cardLevelFixed: faker.datatype.boolean(),
      offlinePointRedemptionEnabled: faker.datatype.boolean(),
      subwayCode: faker.word.sample(),
      authNormalConsultation: faker.datatype.boolean(),
      viewCount: faker.number.int(),
      hospitalContactNumber: faker.phone.number(),
      treatmentCategoryTagList: [
        {
          id: faker.number.int(),
          name: faker.word.sample(),
          label: faker.word.sample(),
          tagMeta: {
            name: faker.word.sample(),
            nameKr: faker.word.sample(),
          },
        },
      ],
      amplitudeTreatmentInfo: {
        treatmentIdList: [faker.number.int()],
        treatmentNameList: [faker.word.sample()],
        treatmentCategoryTagIdList: [faker.number.int()],
        treatmentCategoryTagNameList: [faker.word.sample()],
        treatmentGroupTagNameList: [faker.word.sample()],
        concernBodyPartTagNameList: [faker.word.sample()],
        concernTagNameList: [faker.word.sample()],
        treatmentLabelList: [faker.word.sample()],
        treatmentCategoryTagLabelList: [faker.word.sample()],
        treatmentGroupTagLabelList: [faker.word.sample()],
        concernBodyPartTagLabelList: [faker.word.sample()],
        concernTagLabelList: [faker.word.sample()],
        operationType: faker.word.sample(),
        opTagList: [faker.word.sample()],
        operationTagList: [faker.word.sample()],
      },
      canChatConsultation: faker.datatype.boolean(),
      canPhoneConsultation: faker.datatype.boolean(),
      reviews: [],
      translatedName: faker.company.name(),
      officeHours: faker.lorem.sentence(),
      isOfficeHour: faker.datatype.boolean(),
    },
    isCounselor: faker.datatype.boolean(),
    canConsultation: faker.datatype.boolean(),
    transls: {
      ja: {
        name: faker.company.name(),
        history: faker.lorem.sentence(),
      },
    },
    country: faker.location.country(),
    recentEvalCount: faker.number.int(),
    majorCode: faker.word.sample(),
    majorLicenseNumber: faker.string.alphanumeric(10),
    licenseChangeRequestTime: faker.number.int(),
    treatmentCategoryTagIds: faker.word.sample(),
    hospitalId: faker.number.int(),
    hospitalInfo: {
      id: faker.number.int(),
      updateTime: faker.number.int(),
      name: faker.company.name(),
      introduction: faker.lorem.paragraph(),
      districtCode: faker.word.sample(),
      subwayCode: faker.word.sample(),
      mainImage: faker.image.url(),
      profileImage: faker.image.url(),
      introImage: faker.image.url(),
      cardLevel: faker.number.int(),
      rating: faker.number.int(),
      ratingCount: faker.number.int(),
      pageCount: faker.number.int(),
      reviewCount: faker.number.int(),
      priority: faker.number.int(),
      sigunguCode: faker.word.sample(),
      sido: faker.location.state(),
      sigungu: faker.word.sample(),
      authTenderView: faker.datatype.boolean(),
      authEstimateWrite: faker.datatype.boolean(),
      authChatConsultation: faker.datatype.boolean(),
      authForeignConsultation: faker.datatype.boolean(),
      basicRN: faker.word.sample(),
      basicVN: faker.word.sample(),
      officeHours: faker.lorem.sentence(),
      officeHoursJson: JSON.stringify({
        weekdays: [
          {
            day: 'Monday',
            startTime: '09:00 AM',
            endTime: '06:00 PM',
          },
          {
            day: 'Tuesday',
            startTime: '09:00 AM',
            endTime: '06:00 PM',
          },
          {
            day: 'Wednesday',
            startTime: '09:00 AM',
            endTime: '06:00 PM',
          },
          {
            day: 'Thursday',
            startTime: '09:00 AM',
            endTime: '06:00 PM',
          },
          {
            day: 'Friday',
            startTime: '09:00 AM',
            endTime: '06:00 PM',
          },
          {
            day: 'Saturday',
            startTime: '09:00 AM',
            endTime: '12:00 PM',
          },
        ],
        sunday: [],
        holidays: [],
        other: [],
      }),
      country: faker.location.country(),
      address: faker.location.streetAddress(),
      addressEn: faker.location.streetAddress(),
      zipCode: faker.location.zipCode(),
      lat: Number(faker.location.latitude()),
      lng: Number(faker.location.longitude()),
      mainTel1: faker.phone.number(),
      mainTel2: faker.phone.number(),
      mainTel3: faker.phone.number(),
      emailList: [faker.internet.email()],
      agreedToTermsTime: faker.number.int(),
      canChatConsultation: faker.datatype.boolean(),
      isOfficeHour: faker.datatype.boolean(),
      canPhoneConsultation: faker.datatype.boolean(),
      canNormalConsultation: faker.datatype.boolean(),
      treatmentMenuId: faker.number.int(),
      recentConsultationMemberCount: faker.number.int(),
      recentVisitedMemberCount: faker.number.int(),
      recentOperatedMemberCount: faker.number.int(),
      entranceType: faker.word.sample(),
      assessmentState: faker.word.sample(),
      offlinePointRedemptionEnabled: faker.datatype.boolean(),
      districtNames: null,
      title: faker.lorem.sentence(),
      treatmentCategoryTagIdList: [faker.number.int()],
      opTagList: [faker.word.sample()],
      cardImage: faker.image.url(),
      districtName: faker.word.sample(),
      badgeCodeList: [faker.word.sample()],
      awardList: [faker.word.sample()],
      sidoCode: faker.word.sample(),
      isNew: faker.datatype.boolean(),
      treatmentCategoryTagList: [
        {
          id: faker.number.int(),
          name: faker.word.sample(),
          label: faker.word.sample(),
          tagMeta: {
            name: faker.word.sample(),
            nameKr: faker.word.sample(),
          },
        },
      ],
      amplitudeTreatmentInfo: {
        treatmentIdList: [faker.number.int()],
        treatmentNameList: [faker.word.sample()],
        treatmentCategoryTagIdList: [faker.number.int()],
        treatmentCategoryTagNameList: [faker.word.sample()],
        treatmentGroupTagNameList: [faker.word.sample()],
        concernBodyPartTagNameList: [faker.word.sample()],
        concernTagNameList: [faker.word.sample()],
        treatmentLabelList: [faker.word.sample()],
        treatmentCategoryTagLabelList: [faker.word.sample()],
        treatmentGroupTagLabelList: [faker.word.sample()],
        concernBodyPartTagLabelList: [faker.word.sample()],
        concernTagLabelList: [faker.word.sample()],
        operationType: faker.word.sample(),
        opTagList: [faker.word.sample()],
        operationTagList: [faker.word.sample()],
      },
      ratingShow: faker.datatype.boolean(),
      integratedReviewCount: faker.number.int(),
      officeHoursEtc: faker.lorem.sentence(),
    },
    hospitalName: faker.company.name(),
    amplitudeTreatmentInfo: {
      treatmentIdList: [faker.number.int()],
      treatmentNameList: [faker.word.sample()],
      treatmentCategoryTagIdList: [faker.number.int()],
      treatmentCategoryTagNameList: [faker.word.sample()],
      treatmentGroupTagNameList: [faker.word.sample()],
      concernBodyPartTagNameList: [faker.word.sample()],
      concernTagNameList: [faker.word.sample()],
      treatmentLabelList: [faker.word.sample()],
      treatmentCategoryTagLabelList: [faker.word.sample()],
      treatmentGroupTagLabelList: [faker.word.sample()],
      concernBodyPartTagLabelList: [faker.word.sample()],
      concernTagLabelList: [faker.word.sample()],
      operationType: faker.word.sample(),
      opTagList: [faker.word.sample()],
      operationTagList: [faker.word.sample()],
    },
    majorLicenseConfirmed: faker.datatype.boolean(),
    ratingShow: faker.datatype.boolean(),
  }

  return doctor
}
